<template>
    <div class="content">
        <div class="hw-content">
            <el-collapse v-model="activeNames">
                <el-collapse-item title="合同信息" name="1">
                    <div>
                        <span style="margin-right: 20px">合同信息</span>
                        <el-button v-for="(item, key) in buttonList" :key="key" type="primary" :disabled="item.value == '不可用'" @click="buttonDispose(item.name)">{{ item.name }}</el-button>
                        <span style="margin-left: 50px">打印：</span>
                        <el-button type="primary" @click="SPCOrdersShoppingList_HTML" :disabled="orderDetails.Orders_Status == 3 || orderDetails.Orders_AuditStatus != 1">打印</el-button>
                        <!-- <el-button type="primary" @click="SPCOrdersProductExport">导出商品清单</el-button> -->
                    </div>
                </el-collapse-item>

                <el-collapse-item title="合同基本信息" name="2">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="合同号">
                            <div class="rows">
                                {{ Orders_SN }} (
                                <span :class="judgeColor(Orders_Status)">{{ Orders_Status }}</span>
                                )
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item label="下单时间">
                            <div class="rows">{{ Orders_Addtime | formatDates }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="报价单编号">
                            <div class="rows">{{ orderDetails.Orders_SPCApplySN }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="合同类型">
                            <div class="rows">{{ orderDetails.Orders_TradeType == 1 ? '服务和物联网合同' : '销售合同' }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="审核状态">
                            <span :class="judgeColor(Orders_AuditStatus)">{{ Orders_AuditStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="BPM审核状态">
                            <span class="mr10" :class="judgeColor(Orders_BPMAuditStatus)">{{ Orders_BPMAuditStatus }}</span>
                            <el-button type="primary" v-if="orderDetails.Orders_BPMAuditStatus > 0 && orderDetails.Orders_BPMBizObjectID != ''" @click="searchBpm(orderDetails.Orders_BPMBizObjectID)">查询审批情况</el-button>
                        </el-descriptions-item>
                        <el-descriptions-item label="合同纸回收状态">
                            <span :class="judgeColor(Orders_RecoverStatus)">{{ Orders_RecoverStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="电子签章状态">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="办事处">{{ orderDetails.Orders_OfficeCode }}</el-descriptions-item>
                        <el-descriptions-item label="业务员">{{ officemanInfo.OwnerName }}</el-descriptions-item>
                        <el-descriptions-item label="工程名称">{{ orderDetails.Orders_ProjectName }}</el-descriptions-item>
                        <el-descriptions-item label="工程地址">{{ ProductAddress }}</el-descriptions-item>
                        <el-descriptions-item label="行业分类">{{ ProjectType_name }}</el-descriptions-item>
                        <el-descriptions-item label="是否开具红冲发票">
                            {{ Orders_CreditInvoiceStatus }}
                            <!-- <span :class="judgeColor(result.Detail.RecoverStatusName)">{{ result.Detail.AttachmentAuditName }}</span> -->
                        </el-descriptions-item>

                        <el-descriptions-item labelStyle="color:red;" label="合同备注">
                            <span>{{ orderDetails.Orders_Note }}</span>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="原订单信息" name="3">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="原ERP单号">
                            <div class="rows">{{ orderDetails.Orders_SourceERPSN }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="原订单金额">
                            <div class="rows">¥{{ orderDetails.Orders_SourceOrdersAmount }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="原业务员">
                            {{ orderDetails.Orders_SourceOfficeManName + '[' + orderDetails.Orders_SourceOfficeManCode + ']' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="原合同纸号">
                            {{ orderDetails.Orders_PaperContractSN }}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>
                <el-collapse-item title="客户信息" name="4">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="客户编码	">
                            <div class="rows">{{ orderDetails.Orders_CustomerCode }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="客户名称">
                            <div class="rows">{{ orderDetails.Orders_CustomerName }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="客户姓名" v-if="orderDetails.Orders_CustomerSubID > 0">
                            <div class="rows">{{ customerSubInfo.Customer_Sub_Name }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="年检到期日期">
                            {{ customerInfo.Customer_CertExpireDate ? customerInfo.Customer_CertExpireDate.slice(0, 10) : '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="会员账号">
                            {{ memberInfo.Member_NickName }}
                        </el-descriptions-item>
                        <el-descriptions-item label="姓名">
                            {{ memberInfo.MemberProfileInfo.Member_Name }}
                        </el-descriptions-item>
                        <el-descriptions-item label="固定电话">
                            {{ memberInfo.MemberProfileInfo.Member_Phone_Number || '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="手机">
                            {{ memberInfo.MemberProfileInfo.Member_Mobile }}
                        </el-descriptions-item>
                        <el-descriptions-item label="Email">
                            {{ memberInfo.Member_Email }}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>
                <el-collapse-item title="客户联系人" name="6">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="联系人	">
                            <div class="rows">{{ orderDetails.Orders_Contract_Name }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系电话">
                            <div class="rows">{{ orderDetails.Orders_Contract_Mobile }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人Email">
                            {{ orderDetails.Orders_Contract_Email }}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>
                <el-collapse-item title="电子签章" name="5" v-if="orderDetails.Orders_ESignStatus > 0">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="签章状态">
                            <div class="rows">
                                <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人">
                            <div class="rows">{{ orderDetails.Orders_ESignName }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人手机">
                            <div class="rows">{{ orderDetails.Orders_EsignMobile }}</div>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>
                <el-collapse-item title="关联退货单" name="6">
                    <div>
                        <el-button v-for="(item, key) in batchButtonList" :key="key" :disabled="item == '不可用'" type="primary" @click="batchButtonClk(key)">{{ key }}</el-button>
                    </div>
                    <div style="margin-top: 10px">
                        <el-table :data="returnGoodsList" border style="width: 100%" ref="ordersRelateTble" :header-cell-style="{ backgroundColor: '#EBEEF5' }" @selection-change="handleSelectionChange">
                            <el-table-column align="center" type="selection" width="55" fixed></el-table-column>
                            <el-table-column label="序号" align="center" width="80">
                                <template v-slot="scope">{{ scope.$index + 1 }}</template>
                            </el-table-column>
                            <el-table-column prop="BackBill_SN" label="退货单号" align="center">
                                <template v-slot="scope">
                                    <span class="operation-bar-block" @click="goReturnGoodsDetail(scope.row.BackBill_ID)">{{ scope.row.BackBill_SN }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="BackBill_ERPSN" label="ERP退货单号" align="center"></el-table-column>
                            <el-table-column prop="BackBill_StatusName" label="处理状态" align="center">
                                <template v-slot="scope">
                                    <span>{{ scope.row.BackBill_StatusName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="BackBill_SyncStatusName" label="同步状态" align="center">
                                <template v-slot="scope">
                                    <span :class="judgeColor(scope.row.BackBill_SyncStatusName)">{{ scope.row.BackBill_SyncStatusName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="BackBill_AddTime" label="下单时间" align="center">
                                <template v-slot="scope">{{ scope.row.BackBill_AddTime | formatDates }}</template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="退货清单" name="7">
                    <el-table :data="returnGoodsdeDetailList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="Goods_Product_Code" label="商品编码" align="center"></el-table-column>
                        <el-table-column prop="Goods_Product_Name" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Goods_Product_SourcePrice" label="原始价格" align="center">
                            <template v-slot="scope">
                                <span class="is-status-text">￥ {{ Number(scope.row.Goods_Product_SourcePrice.toFixed(4)) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Goods_Product_Price" label="申请价格" align="center">
                            <template v-slot="scope">
                                <span class="is-status-text">￥ {{ Number(scope.row.Goods_Product_Price.toFixed(4)) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Goods_Product_Amount" label="数量" align="center"></el-table-column>
                        <el-table-column prop="Goods_Product_SourcePrice" label="合计" align="center">
                            <template v-slot="scope">
                                <div class="is-status-text">
                                    {{ Number((scope.row.Goods_Product_Price * scope.row.Goods_Product_Amount).toFixed(4)) }}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin-top: 10px">
                        退货金额合计：
                        <span class="is-status-text">￥{{ Number(returnGoodsdePirce) }}</span>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="审核说明" name="8">
                    <el-table :data="auditLise" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="No" label="序号" align="center" width="80">
                            <template v-slot="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Note_Note" label="备注" align="left" show-overflow-tooltip></el-table-column>
                    </el-table>
                </el-collapse-item>

                <el-collapse-item title="变更申请日志" name="9">
                    <el-table :data="ordersLogsList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="No" label="序号" align="center" width="80">
                            <template v-slot="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Orders_Log_Addtime" label="时间" align="center" width="150">
                            <template v-slot="scope">
                                <span>{{ scope.row.Orders_Log_Addtime | formatDates }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Orders_Log_Operator" label="操作人" align="center" width="150"></el-table-column>
                        <el-table-column prop="Orders_Log_Remark" label="备注" align="left"></el-table-column>
                    </el-table>
                </el-collapse-item>
                <!-- <el-collapse-item title="合同附件" name="8">
                    <el-table :data="result.Attachment" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="No" label="序号" align="center" width="80">
                            <template v-slot="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Attachment_Source" label="附件文件" align="center" width="300" show-overflow-tooltip>
                            <template v-slot="scope">
                                <span class="operation-bar-block" @click="downFile(scope.row.Attachment_Path)">{{ scope.row.Attachment_Source }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Attachment_AuditNote" label="审核备注" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Attachment_Addtime" label="上传时间" align="center" width="150">
                            <template v-slot="scope">
                                {{ scope.row.Attachment_Addtime | formatDates }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item> -->
                <el-collapse-item title="查看历史附件" name="5" v-if="result.IsShowHistory">
                    <el-table :data="History" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="No" label="序号" align="center" width="80">
                            <template v-slot="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Attachment_Source" label="附件文件" align="center" width="300" show-overflow-tooltip>
                            <template v-slot="scope">
                                <span class="operation-bar-block" @click="downFile(scope.row.Attachment_Path)">{{ scope.row.Attachment_Source }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Attachment_AuditNote" label="审核备注" align="center" show-overflow-toolti></el-table-column>
                        <el-table-column prop="Attachment_Addtime" label="上传时间" align="center" width="150">
                            <template v-slot="scope">
                                {{ scope.row.Attachment_Addtime | formatDates }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>
            </el-collapse>
        </div>
        <BPMExamine :isSwitch="isSwitch" :id="orderDetails.Orders_BPMBizObjectID" @setSwitchClose="setSwitchClose" v-if="isSwitch"></BPMExamine>
        <PrintHtml :isSwitch="printSwitch" :html="printHtml" :numsituation="numsituation" :marginOfSeal="130" :sealTrue="sealTrue" @setSwitchClose="printSwitchClose" v-if="printSwitch"></PrintHtml>
        <ResendContractDialog v-if="resendSwitch" :visible="resendSwitch" :result="result" @refresh="handleRefresh" @close="resendSwitchClose" />
        <el-dialog :visible.sync="BatchUploadShow" width="1000px" :before-close="handleClose" v-if="BatchUploadShow">
            <div>
                <BatchUpload :orderOperate="orderOperate" @BatchUploadRes="BatchUploadRes"></BatchUpload>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="BatchPaymentShow" width="1600px" :before-close="handleClose" v-if="BatchPaymentShow">
            <div>
                <BatchPayment :orderOperate="orderOperate" @BatchPaymentRes="BatchPaymentRes"></BatchPayment>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="BatchDeliverShow" width="1600px" :before-close="handleClose" v-if="BatchDeliverShow">
            <div>
                <BatchDeliver :orderOperate="orderOperate" @BatchDeliverRes="BatchDeliverRes"></BatchDeliver>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="BatchTicketShow" width="1600px" :before-close="handleClose" v-if="BatchTicketShow">
            <div>
                <BatchTicket :orderOperate="orderOperate" @BatchTicketRes="BatchTicketRes"></BatchTicket>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="BatchInvoiceShow" width="1600px" :before-close="handleClose" v-if="BatchInvoiceShow">
            <div>
                <BatchInvoice :orderOperate="orderOperate" @BatchInvoiceRes="BatchInvoiceRes"></BatchInvoice>
            </div>
        </el-dialog>
        <el-dialog title="提交合同" :visible.sync="submitOrderShow" v-if="submitOrderShow" width="1500px" top="5vh" style="height: 90vh">
            <SubmitPackOrder :submitOrderData="submitOrderData" @submitOrderComplete="submitOrderComplete"></SubmitPackOrder>
        </el-dialog>
    </div>
</template>

<script>
import BPMExamine from '@/components/BPMExamine';
import PrintHtml from '@/components/PrintHtml';
import ResendContractDialog from '@/components/ResendContract';
import BatchUpload from '@/views/orderManagement/operateBatch/BatchUpload';
import BatchPayment from '@/views/orderManagement/operateBatch/BatchPayment';
import BatchDeliver from '@/views/orderManagement/operateBatch/BatchDeliver';
import BatchTicket from '@/views/orderManagement/operateBatch/BatchTicket';
import BatchInvoice from '@/views/orderManagement/operateBatch/BatchInvoice';
import SubmitPackOrder from './returnSubmitOrder.vue';
export default {
    name: 'returnManageDetails',
    components: {
        BPMExamine,
        PrintHtml,
        ResendContractDialog,
        BatchUpload,
        BatchPayment,
        BatchDeliver,
        BatchTicket,
        BatchInvoice,
        SubmitPackOrder
    },
    data() {
        return {
            id: '',
            Orders_Status: '',
            Orders_SN: '',
            Orders_Addtime: '',
            Orders_AuditStatus: '',
            Orders_BPMAuditStatus: '',
            Orders_RecoverStatus: '',
            ProjectType_name: '',
            orderList: [
                { title: '合同号', value: '' },
                { title: '合同状态', value: '' },
                { title: '下单时间', value: '' }
            ],
            sMDSPipelineShow: false, // 展示关联商机信息
            returnsSingle: false, //是否为仅退货
            sMDSPipelineData: {}, // 关联商机信息
            OrdersSourceCate: 0, //订单类型，0报价单1合同变更2独立合同
            Orders_CreditInvoiceStatus: '', //是否开具红冲发票
            ProductAddress: '', // 地址
            details: {},
            activeNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
            orderDetails: { Orders_ESignStatus: 0, Orders_ESignName: '', Orders_EsignMobile: '' }, //合同详情，用来判断电子签章是否显示
            Orders_ESignStatus: '',
            returnGoodesPorductPirce: 0,
            resendSwitch: false, // 重发合同弹窗
            result: {
                Detail: {
                    Office_Name: '',
                    Orders_OfficeMan: '',
                    Orders_SPCOrdersSN: '',
                    BackBillSyncStatusName: '',
                    BackBillStatusName: '',
                    AttachmentAuditName: '',
                    RecoverStatusName: '',
                    RMAName: '--',
                    Orders_ProjectName: '',
                    BackBill_AddTime: '',
                    BackBill_AttachmentAudit: 1,
                    BackBill_AttachmentAudit_Time: '',
                    BackBill_ContractPaperSN: '',
                    BackBill_CustomerCode: '',
                    BackBill_CustomerID: 279,
                    BackBill_CustomerName: '',
                    BackBill_ERPSN: '',
                    BackBill_ID: 9,
                    BackBill_OfficeCode: '',
                    BackBill_OfficeID: 191,
                    BackBill_OfficeManCode: '',
                    BackBill_OfficeManID: 54,
                    BackBill_OrdersERPSN: '',
                    BackBill_RMA: 0,
                    BackBill_RecoverStatus: 0,
                    BackBill_SN: '',
                    BackBill_SPCOrdersID: 342,
                    BackBill_Status: 1,
                    BackBill_SyncStatus: 0,
                    BackBill_SyncTime: '',
                    BackBill_TotalPrice: 90.65
                },

                Goods: [],
                Attachment: [],
                IsUpload: false,
                IsShowHistory: false
            },
            History: [],
            returnGoodsList: [], //关联退货单
            ReturnGoodsId: [], //当前选中的批量操作退货单id
            returnGoodsdeDetailList: [], //退货清单
            returnGoodsdePirce: '', //退货清单总金额

            buttonList: [], //订单详情按钮
            buttonResult: {}, //订单详情按钮
            memberInfo: {
                Member_NickName: '', // 会员昵称
                Member_Email: '', // 会员邮箱
                MemberProfileInfo: {
                    Member_Name: '', // 会员姓名
                    Member_Phone_Number: '', // 会员电话
                    Member_Mobile: '' // 会员手机
                }
            }, // 办事处成员信息
            officemanInfo: {}, // 办事处信息
            customerSubInfo: {}, // 二级客户信息
            customerInfo: {}, // 客户信息
            batchButtonList: {}, // 批量操作按钮
            BatchOrderId: [], // 批量操作订单ID
            isSwitch: false, // bpm审核弹窗
            isReturnGoods: 0, //是否返货
            printSwitch: false, // 打印弹窗
            printHtml: '', // 打印内容
            ordersLogsList: [], //合同日志
            auditLise: [], //审核说明
            orderOperate: {}, // 订单操作数据
            BatchUploadShow: false, // 批量上传弹窗
            BatchPaymentShow: false, // 批量付款弹窗
            BatchDeliverShow: false, // 批量发货弹窗
            BatchTicketShow: false, // 批量开票弹窗
            BatchInvoiceShow: false, // 批量盖章弹窗
            numsituation: 0, // 打印印章情况
            sealTrue: false, // 打印盖章
            submitOrderShow: false, //  提交合同弹唱
            submitOrderData: {} //提交合同数据
        };
    },
    watch: {
        isdetails(newval, oldval) {
            if (newval) {
                this.getOrderDetails(this.id);
            }
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.getOrderDetails(this.id);
    },
    methods: {
        // 获取订单详情
        async getOrderDetails() {
            var result = await this.$newsApi.order.getSPCOrdersByID({
                ID: this.id
            });
            this.result = result.data.data;
            const orderInfo = result.data.data;
            if (orderInfo.Orders_Status == -1) {
                this.$message({
                    type: 'warning',
                    title: '临时合同不可查看详情'
                });
                return;
            }
            if (orderInfo.Extend && orderInfo.Extend.Orders_SMDSPipelineID) {
                this.sMDSPipelineShow = true;
                this.sMDSPipelineData = JSON.parse(orderInfo.Extend.Orders_SMDSPipelineInfo);
                console.log(this.sMDSPipelineData);
            }

            orderInfo.addressDetails = '';
            orderInfo.projectDetails = '';
            this.orderDetails = orderInfo;
            console.log(this.orderDetails, 'orderDetails');
            // if (orderInfo.Orders_CustomerSubID > 0) {
            // 	// 存在二级客户
            // 	await this.GetCustomerSubByID(result.data.Orders_CustomerSubID);
            // }

            this.OrdersSourceCate = orderInfo.Orders_SourceCate;
            let SPCOrderButton = {
                Orders_BPMAuditStatus: orderInfo.Orders_BPMAuditStatus,
                Orders_Status: orderInfo.Orders_Status,
                OrdersID: orderInfo.Orders_ID,
                Orders_ESignStatus: orderInfo.Orders_ESignStatus
            };
            // 退货单
            if (this.OrdersSourceCate == 1) {
                this.returnsSingle = this.OrdersSourceCate == 1 ? true : false;
                let orderRequests = [
                    this.GetCreditInvoiceStatus(orderInfo.Orders_CreditInvoiceStatus), //红冲发票
                    this.GetDisplayAddress(orderInfo),

                    this.GetSPCOrdersRelateBackBillList(), //关联退款单
                    this.GetSPCOrdersBackGoodsByOrdersID(), //退货清单
                    this.GetAuditStatus(orderInfo), //订单审核状态
                    this.OrdersBPMAuditStatus(orderInfo), //BPM审核状态
                    this.OrdersContractReceive(orderInfo), //合同纸回收状态
                    this.OrdersESignStatus(orderInfo), //电子签章状态
                    this.DisplayProjectTypeRecursion(orderInfo), //行业分类
                    this.GetOrderDetailButton(orderInfo), //订单详情按钮
                    this.GetBranchOfficeMemberByID(orderInfo.Orders_OfficeManID),
                    this.getCustomerByID(orderInfo.Orders_CustomerID),
                    this.GetCustomerSubByID(orderInfo.Orders_CustomerSubID),
                    this.getMemberByID(orderInfo.Orders_BuyerID),
                    this.SPCOrder_Detail_BatchButton(SPCOrderButton), // 批量操作按钮9
                    this.GetOrdersAuditNotesByOrdersID(orderInfo.Orders_ID),
                    this.GetSPCOrdersLogsByOrdersID(orderInfo.Orders_ID)
                ];
                await Promise.all(orderRequests);
            }

            await this.GetOrdersStatus(orderInfo);
        },
        GetBranchOfficeMemberByID(id) {
            this.$newsApi.order.GetBranchOfficeMemberByID({ MemberID: id }).then((res) => {
                this.officemanInfo = res.data.data;
            });
        },
        getCustomerByID(id) {
            this.$newsApi.order.getCustomerByID({ CustomerID: id }).then((res) => {
                this.customerInfo = res.data.data;
            });
        },
        GetCustomerSubByID(id) {
            if (!id) return;
            this.$newsApi.order.GetCustomerSubByID({ ID: id }).then((res) => {
                this.customerSubInfo = res.data.data;
            });
        },
        getMemberByID(id) {
            this.$newsApi.order.getMemberByID({ MemberID: id }).then((res) => {
                this.memberInfo = res.data.data;
            });
        },
        SPCOrder_Detail_BatchButton(SPCOrderButton) {
            this.$newsApi.contract.SPCOrder_Detail_BatchButton(SPCOrderButton).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.batchButtonList = res.data.data;
                }
            });
        },

        // 订单按钮操作统一处理
        buttonDispose(e) {
            switch (e) {
                case '取消':
                case '取消':
                    if (this.buttonResult['取消提示']) {
                        this.$confirm(this.buttonResult['取消提示'], '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        })
                            .then(() => {
                                this.userCancle();
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: '已取消'
                                });
                            });
                    } else {
                        this.userCancle();
                    }
                    break;
                case '提交':
                    if (this.buttonResult['提交提示']) {
                        this.$confirm(this.buttonResult['提交提示'], '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        })
                            .then(() => {
                                this.goSubmitOrder();
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: '已取消'
                                });
                            });
                    } else {
                        this.goSubmitOrder();
                    }
                    break;
                case '修改':
                    this.changeOrder();
                    break;
                case '撤回电子签章':
                    this.contractsRevoke();
                    break;
                case '重发电子签章':
                    this.resendContract();
                    break;
            }
        },
        userCancle() {
            this.$prompt('请输入取消原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputType: 'textarea',
                inputPattern: /.+/,
                inputErrorMessage: '取消原因不能为空'
            }).then(({ value }) => {
                let data = {
                    Orders_ID: this.id,
                    orders_cancel_note: value
                };
                this.$newsApi.order.SPCOrders_Cancel({ json: JSON.stringify(data) }).then((res) => {
                    console.log(res);
                    this.getOrderDetails(this.id);
                });
            });
        },
        resendContract() {
            this.resendSwitch = true;
        },
        resendSwitchClose() {
            this.resendSwitch = false;
        },
        handleRefresh() {
            this.getOrderDetails(this.id);
        },
        contractsRevoke() {
            this.$prompt('请输入撤销原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /.+/,
                inputErrorMessage: '撤销原因不能为空'
            }).then(({ value }) => {
                let data = {
                    orders_cancel_note: value
                };
                this.$newsApi.contract.SPCOrdersContractsRevoke({ orders_id: this.id, json: JSON.stringify(data) }).then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.$message.success('撤销成功');
                    }
                    this.handleRefresh();
                });
            });
        },
        async goSubmitOrder() {
            console.log('提交');
            let orderResult = await this.CheckOrdersConfirm();
            if (orderResult.Resultcode == 1) {
                 await this.$alert(orderResult.Resultinfo, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                });
                return;
            }
            this.submitOrderData = { relation: 0, id: this.id };
            this.submitOrderShow = true;
            // this.$router.push({ path: '/contractreturnManagement/returnSubmitOrder', query: { relation: 0, id: this.id } });
        },
        // 订单详情检查提交
        async CheckOrdersConfirm() {
            let json = JSON.stringify({ relation: 0 });
            let loadingInstance = this.$loading(); // 显示 loading
            const result = await this.$newsApi.contract.CheckSPCOrdersConfirm({
                OrdersID: this.id,
                Json: json
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            return result.data;
        },
        //修改
        changeOrder() {
            this.$router.push({ path: '/contractreturnManagement/applyReturn', query: { id: this.id } });
        },
        //获取关联退货单
        async GetSPCOrdersRelateBackBillList() {
            let result = await this.$newsApi.order.getSPCOrdersRelateBackBillList({
                orders_id: this.id
            });
            if (result.data.data) {
                this.ReturnGoodsId = [];
                this.returnGoodsList = result.data.data;
                this.$nextTick(() => {
                    if (this.returnGoodsList && this.returnGoodsList.length > 0) {
                        this.$refs.ordersRelateTble.toggleAllSelection();
                    }
                });
            } else {
                this.returnGoodsList = [];
            }
        },
        //获取退货清单
        async GetSPCOrdersBackGoodsByOrdersID() {
            let result = await this.$newsApi.order.getSPCOrdersBackGoodsByOrdersID({
                orders_id: this.id
            });
            this.returnGoodsdeDetailList = result.data.data;
            this.returnGoodsdePirce = 0;
            if (result.data.data) {
                for (let i = 0; i < result.data.data.length; i++) {
                    const el = result.data.data[i];
                    this.returnGoodsdePirce += Number((el.Goods_Product_Price * el.Goods_Product_Amount).toFixed(2));
                }
                this.returnGoodsdePirce = this.returnGoodsdePirce.toFixed(2);
            }
        },

        //获取是否开具红冲发票
        async GetCreditInvoiceStatus(status) {
            let result = await this.$newsApi.order.getCreditInvoiceStatus({
                status: status
            });
            this.Orders_CreditInvoiceStatus = result.data.data;
        },
        async GetDisplayAddress(req) {
            let result = await this.$newsApi.common.getDisplayAddress({
                countryCode: req.Orders_ProjectCountry,
                stateCode: req.Orders_ProjectState,
                CityCode: req.Orders_ProjectCity,
                CountyCode: req.Orders_ProjectCounty
            });
            this.ProductAddress = result.data.resultinfo;
        },

        //订单详情-获取订单状态
        async GetOrdersStatus(req) {
            let result = await this.$newsApi.order.getOrdersStatus({
                status: req.Orders_Status
            });
            this.Orders_Status = result.data.data;
            this.Orders_SN = req.Orders_SN;
            this.Orders_Addtime = req.Orders_Addtime;
        },
        // 订单详情-获取订单审核状态
        async GetAuditStatus(req) {
            let result = await this.$newsApi.order.GetAuditStatus({
                status: req.Orders_AuditStatus
            });
            this.Orders_AuditStatus = result.data.data;
        },
        // 订单详情-获取BPM审核状态
        async OrdersBPMAuditStatus(req) {
            let result = await this.$newsApi.order.OrdersBPMAuditStatus({
                status: req.Orders_BPMAuditStatus
            });
            this.Orders_BPMAuditStatus = result.data.data;
        },
        // 订单详情-获取合同纸回收状态
        async OrdersContractReceive(req) {
            let result = await this.$newsApi.order.OrdersContractReceive({
                status: req.Orders_RecoverStatus
            });
            this.Orders_RecoverStatus = result.data.data;
        },
        // 订单详情-获取电子签章状态
        async OrdersESignStatus(req) {
            let result = await this.$newsApi.order.OrdersESignStatus({
                status: req.Orders_ESignStatus
            });
            this.Orders_ESignStatus = result.data.data;
        },
        // 订单详情-展示项目名称
        async DisplayProjectTypeRecursion(e) {
            var result = await this.$newsApi.order.DisplayProjectTypeRecursion({
                ID: e.Orders_ProjectType_ID
            });
            this.ProjectType_name = result.data.data;
        },

        async GetOrdersAuditNotesByOrdersID(req) {
            console.log(req.Orders_ID, 'req');
            let result = await this.$newsApi.contract.GetOrdersAuditNotesByOrdersID({
                orders_id: this.id
            });
            this.auditLise = result.data.data;
        },
        async GetSPCOrdersLogsByOrdersID(req) {
            console.log(req.Orders_ID, 'req');
            let result = await this.$newsApi.contract.GetSPCOrdersLogsByOrdersID({ OrdersID: this.id });
            this.ordersLogsList = result.data.data;
        },
        handleClose(done) {
            // 关闭所有弹窗
            this.BatchUploadShow = false;
            this.BatchPaymentShow = false;
            this.BatchDeliverShow = false;
            this.BatchTicketShow = false;
            this.BatchInvoiceShow = false;
            this.submitOrderShow = false;
            
            // 如果有done回调函数，调用它来关闭弹窗
            if (done && typeof done === 'function') {
                done();
            }
            
            // 触发父组件的handleClose事件
            this.$emit('handleClose');
        },
        /*
        打开文件
        */
        downFile(par, flag) {
            if (flag) {
                window.open(par);
                return;
            }
            this.$newsApi.common.getUrlPath().then((res) => {
                if (res.data.Resultcode == 0) {
                    let path = res.data.data;
                    let paths = path + par;
                    window.open(paths);
                }
            });
        },
        //获取订单详情按钮
        async GetOrderDetailButton(orderInfo) {
            var result = await this.$newsApi.order.SPCOrder_Detail_Button({
                Orders_ID: this.id,
                Orders_Status: orderInfo.Orders_Status,
                Orders_AuditStatus: orderInfo.Orders_Status,
                Orders_BPMAuditStatus: orderInfo.Orders_BPMAuditStatus,
                Orders_FreightType: orderInfo.Orders_FreightType,
                Orders_PrePay_Percent: orderInfo.Orders_PrePay_Percent,
                Orders_PaperContractSN: orderInfo.Orders_PaperContractSN,
                Orders_SourceCate: orderInfo.Orders_SourceCate,
                Orders_ESignStatus: orderInfo.Orders_ESignStatus,
                orders_sn: orderInfo.Orders_SN
            });
            var arr = [];
            result = result.data;
            if (result.data) {
                for (var key in result.data) {
                    if (result.data[key] == '可用' || result.data[key] == '不可用') {
                        var obj = {};
                        obj.name = key;
                        obj.value = result.data[key];
                        arr.push(obj);
                    }
                }
            }
            this.buttonResult = result.data;
            this.buttonList = arr;
        },
        // 跳转订单详情
        batchButtonClk(item) {
            let json = this.BatchOrderId.map((item) => {
                return item.BackBill_ID;
            }).join();
            let obj = { OrdersID: this.id, backbillOrderId: json ,OrdersSN:this.Orders_SN,batchOrderId:this.batchOrderId};
            this.orderOperate = obj;
            switch (item) {
                case '上传附件':
                    this.BatchUploadShow = true;
                    break;
                case '批量支付':
                    this.BatchPaymentShow = true;
                    break;
                case '批量发货':
                    this.BatchDeliverShow = true;
                    break;
                case '批量开票':
                    this.BatchTicketShow = true;
                    break;
                case '批量免盖章':
                    this.orderOperate.status = 1;
                    this.BatchInvoiceShow = true;
                    break;
                case '批量取消免盖章':
                    this.orderOperate.status = 0;
                    this.BatchInvoiceShow = true;
                    break;
            }
        },
        handleSelectionChange(val) {
            this.BatchOrderId = val;
        },
        // 查看BPM审核
        searchBpm(e) {
            this.isSwitch = true;
        },
        setSwitchClose() {
            this.isSwitch = false;
        },
        // 打印合同
        SPCOrdersShoppingList_HTML(e) {
            this.$newsApi.order.SPCOrdersShoppingList_HTML({ OrdersID: this.id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.printHtml = res.data.data;
                    this.$newsApi.order.SPCOrders_Goods_List_HTML({ OrdersID: this.id }).then((res) => {
                        if (res.data.Resultcode == 0) {
                            this.sealTrue = this.result.Orders_BPMAuditStatus == 2 ? true : false; // 是否打印印章
                            this.printHtml = this.printHtml + '<div class="PageNext">&nbsp;</div>' + res.data.data;
                            let IsPaperContractSN = false;
                            if (this.result.Orders_PaperContractSN.length > 0) {
                                IsPaperContractSN = true;
                            }
                            if (this.result.Orders_SourceCate == 1) {
                                IsPaperContractSN = false;
                            }
                            let numsituation = 0;
                            if (IsPaperContractSN) {
                                if (this.result.Orders_BPMAuditStatus == 2) {
                                    numsituation = 1;
                                } else {
                                    numsituation = 2;
                                }
                            } else {
                                if (this.result.Orders_BPMAuditStatus == 2) {
                                    numsituation = 3;
                                }
                            }
                            this.numsituation = numsituation;
                            this.printSwitch = true;
                        }
                    });
                }
            });
        },
        // 查看商品清单
        SPCOrdersProductExport(e) {
            this.$newsApi.order
                .SPCOrdersProductExport({ orders_id: this.id })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        window.open(this.$fileUrl + res.data.data, '_blank');
                        this.$message.success('导出成功，文件已开始下载'); // 添加成功提示
                    } else {
                        this.$message.error(`导出失败: ${res.data.Resultinfo}`); // 添加失败提示
                    }
                })
                .catch((error) => {
                    this.$message.error('导出请求失败' + error); // 网络错误提示
                });
        },
        printSwitchClose() {
            this.printSwitch = false;
        },
        resendSwitchClose() {
            this.resendSwitch = false;
        },
        goReturnGoodsDetail(e) {
            this.$router.push({ path: '/contractreturnManagement/returnGoodsDetails', query: { id: e } });
        },
        // 批量上传
        BatchUploadRes(e) {
            this.BatchUploadShow = false;
            if (e) {
                // 刷新订单详情
                this.getOrderDetails(this.id);
            }
        },
        // 批量付款
        BatchPaymentRes(e) {
            this.BatchPaymentShow = false;
            if (e) {
                // 刷新订单详情
                this.getOrderDetails(this.id);
            }
        },
        // 批量发货
        BatchDeliverRes(e) {
            this.BatchDeliverShow = false;
            if (e) {
                // 刷新订单详情
                this.getOrderDetails(this.id);
            }
        },
        // 批量开票
        BatchTicketRes(e) {
            this.BatchTicketShow = false;
            if (e) {
                // 刷新订单详情
                this.getOrderDetails(this.id);
            }
        },
        // 批量免盖章
        BatchInvoiceRes(e) {
            this.BatchInvoiceShow = false;
            if (e) {
                // 刷新订单详情
                this.getOrderDetails(this.id);
            }
        },
        submitOrderComplete() {
            this.submitOrderShow = false;
            this.getOrderDetails(this.id);
            this.$router.push({ path: '/contractreturnManagement/index?t=' + Date.now() });
        }
    }
};
</script>

<style lang="scss" scoped>
/* .hw-content 的样式 */
.hw-content {
    padding: 0 20px;
}

/* 通用样式 */
.rows {
    width: 389px;
}

.content {
    background: #fff;
    padding: 20px 0;
}

/deep/.el-table th.el-table__cell.is-leaf,
.el-table td.el-table__cell {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

/deep/.el-table--border .el-table__cell {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

/deep/.el-table {
    border: 1px solid #ccc;
}
</style>
